/** Mirrors backend learning_tutorial/layer_types.py */

export const SYNC_AT_SCENE_START_TYPES = new Set([
  'scene_title',
  'bullet',
  'explanation',
  'keyword',
]);

export const NARRATION_GATED_ARTIFACT_TYPES = new Set([
  'image',
  'flowchart_node',
  'flowchart_arrow',
  'code_step',
  'code_highlight',
  'console_output',
]);

export const NARRATION_GATED_SEGMENT_ROLES = new Set(['visual', 'code', 'console', 'demo']);

export function isNarrationGatedBlock(type, segmentRole) {
  const t = (type || '').trim();
  if (NARRATION_GATED_ARTIFACT_TYPES.has(t)) return true;
  return NARRATION_GATED_SEGMENT_ROLES.has((segmentRole || '').trim());
}

export function isNarrationGatedElement(el) {
  return isNarrationGatedBlock(el?.type, el?.segment_role);
}
